'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    CreditCard,
    Shield,
    Lock,
    Zap,
    Globe,
    BarChart
} from 'lucide-react';

export function PaymentGatewayIntegrationContent() {
    const t = useTranslations('paymentGatewayIntegration');

    const features = [
        {
            icon: Zap,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Shield,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: CreditCard,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: Globe,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: BarChart,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: Lock,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="payment-gateway-integration"
            translationNamespace="paymentGatewayIntegration"
            features={features}
            benefits={benefits}
            ctaIcon={CreditCard}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/Payment-gateway.webp"
            introImageAlt={t('intro.imageAlt') || 'Payment Gateway Integration in MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="payment-gateway-integration"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About Payment Gateway Integration'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'Payment Gateway Integration'}
            useLocaleContent={true}
        />
    );
}

